<div class="fcp-select">
    <div
        class="fcp-select-container"
        [ngClass]="{ 'fcp-select-container-opened': isOpened, 'fcp-select-container-disabled': disabled }"
        clickOutside
        (clickOutside)="clickedOutside()"
    >
        <div class="fcp-select-toggler" (click)="toggleMenu()">
            <div class="fcp-toggler">
                <div class="fcp-toggler-label">
                    {{ selectedItem?.label }}
                </div>
                <div class="fcp-toggler-icon">
                    <fcp-icon [icon]="['fal', 'chevron-down']"></fcp-icon>
                </div>
            </div>
        </div>
        <div class="fcp-select-menu" *ngIf="isOpened">
            <div class="fcp-menu">
                <div
                    class="fcp-menu-item"
                    *ngFor="let item of items"
                    (click)="handleClick(item)"
                    [ngClass]="{ 'fcp-menu-item-selected': item === selectedItem }"
                >
                    <div class="fcp-menu-item-label">
                        <span>{{ item.label }}</span>
                    </div>
                    <div class="fcp-menu-item-icon">
                        <fcp-icon
                            *ngIf="item === selectedItem"
                            [icon]="['fal', 'check']"
                            [style]="'color:var(--interactive-13);'"
                        ></fcp-icon>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
